import client from "./client";

const getCompanyById = (id) => {
  return client
    .get(`/companies/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};

const getCompanies = (filter) => {
  return client
    .get(`/companies/paginated`, filter)
    .then((response) => {
      return response.data;
    })
    .catch((error) => error.response);
};

const createCompany = (data) => {
  return client
    .post("/companies", data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const deleteCompany = (id) => {
  return client
    .delete(`/companies/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
};

const updateCompany = (data) => {
  return client
    .put(`/companies/${data.id}`, data)
    .then((response) => {
      return response;
    }).catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const generateRegisterLink = () => {
  return client
    .post("/register-links/company")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const validateRegisterToken = (token) => {
  return client
    .post("/register-links/validate/company", { token })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const registerWithToken = (data) => {
  return client
    .post("/register-links/register/company", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error.response.data);
    });
};

const deactivateCompany = (id) => {
  return client
    .put(`/companies/${id}/deactivate`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
};

const activateCompany = (id) => {
  return client
    .put(`/companies/${id}/activate`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error.response?.data || error);
    });
};

const companyAPI = {
  createCompany,
  updateCompany,
  deleteCompany,
  getCompanies,
  getCompanyById,
  generateRegisterLink,
  validateRegisterToken,
  registerWithToken,
  deactivateCompany,
  activateCompany,
};

export default companyAPI;
